import React from "react";
import CalendarEventCard from "./CalendarEventCard";
import { CalendarServiceInstance, formatLongDate, instancesForDay } from "./calendarUtils";

interface Props { selectedDate: Date; instances: CalendarServiceInstance[]; onOpen: (instance: CalendarServiceInstance) => void; className?: string; }

export default function SelectedDayPanel({ selectedDate, instances, onOpen, className = "" }: Props) {
  const dayInstances = instancesForDay(instances, selectedDate);
  return (
    <section className={`calendar-day-panel ${className}`.trim()}>
      <header><h2>{formatLongDate(selectedDate)}</h2><p>{dayInstances.length} service{dayInstances.length === 1 ? "" : "s"} scheduled</p></header>
      {dayInstances.length > 0 ? dayInstances.map((instance) => <CalendarEventCard key={instance.serviceInstanceId} instance={instance} onOpen={onOpen} />) : <div className="calendar-day-empty">No services scheduled for this day.</div>}
    </section>
  );
}
